import { Box, Text, WizardStepRenderParams } from '@factorialco/deprecated-design-system'
import { NumberInput } from '@factorialco/f0-react/dist/experimental'

import Callout from 'modules/core/components/Callout'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { ClassWizardData } from 'modules/trainings/components/Revamp/NewClassWizard/hooks/useNewClassWizardSteps'
import {
  SalaryCostCalculator,
  SalaryCostInfo,
} from 'modules/trainings/components/SalaryCostCalculator'

export const CostsStep = ({ data, onDataChanged }: WizardStepRenderParams<ClassWizardData>) => {
  const { company } = useCurrentSession()
  const salaryCostInfo = new SalaryCostInfo(data.employeesSelection)
  data.trainingSessions.forEach((session) => {
    if (session.startsAt) {
      salaryCostInfo.appendFromBackend(session.startsAt, Number(session.duration) || 0)
    }
  })

  const currency = company.currency || ''

  return (
    <Box gap="s32" paddingX="s16">
      <Box gap="s16">
        <Box gap="s8">
          <Text size="400" weight="semibold" color="grey1000">
            {i18n.t('trainings.trainings_revamp.training_class.class_wizard.costs_step.title')}
          </Text>
          <Text size="200" weight="normal">
            {i18n.t(
              'trainings.trainings_revamp.training_class.class_wizard.costs_step.description'
            )}
          </Text>
        </Box>
        <Box gap="s8">
          <Text size="300" color="textPrimary" weight="semibold">
            {i18n.t(
              'trainings.trainings_revamp.training_class.class_wizard.basic_information_step.cost'
            )}
          </Text>
          <Text size="200">{i18n.t('trainings.classes.cost_desc')}</Text>
          <NumberInput
            size="md"
            label={i18n.t('trainings.classes.cost_desc')}
            hideLabel
            locale={i18n.locale}
            units={currency}
            placeholder="0.00"
            onChange={(value) =>
              onDataChanged({ ...data, cost: value !== null ? String(value) : '' })
            }
            value={data.cost ? Number(data.cost) : null}
            maxDecimals={2}
          />
        </Box>
        <Box gap="s8">
          <Text size="300" color="textPrimary" weight="semibold">
            {i18n.t('trainings.classes.indirect_cost')}
          </Text>
          <Text size="200">{i18n.t('trainings.classes.indirect_cost_desc')}</Text>
          <NumberInput
            size="md"
            label={i18n.t('trainings.classes.indirect_cost_desc')}
            hideLabel
            locale={i18n.locale}
            units={currency}
            placeholder="0.00"
            onChange={(value) =>
              onDataChanged({ ...data, indirectCost: value !== null ? String(value) : '' })
            }
            value={data.indirectCost ? Number(data.indirectCost) : null}
            maxDecimals={2}
          />
        </Box>
        <Box gap="s8">
          <Text size="300" color="textPrimary" weight="semibold">
            {i18n.t('trainings.classes.salary_cost')}
          </Text>
          <Text size="200">{i18n.t('trainings.classes.salary_cost_desc')}</Text>
          <Box gap="s16" flexDirection="row" alignItems="center">
            <Box flexGrow>
              <NumberInput
                size="md"
                label={i18n.t('trainings.classes.salary_cost_desc')}
                hideLabel
                locale={i18n.locale}
                units={currency}
                placeholder="0.00"
                onChange={(value) =>
                  onDataChanged({ ...data, salaryCost: value !== null ? String(value) : '' })
                }
                value={data.salaryCost ? Number(data.salaryCost) : null}
                maxDecimals={2}
              />
            </Box>
            <SalaryCostCalculator
              salaryCostInfo={salaryCostInfo}
              onApply={(value: string) => {
                onDataChanged({ ...data, salaryCost: value })
                return true
              }}
              trackingSelectedFrom="group_creation"
              currency={currency}
            />
          </Box>
        </Box>
        <Callout type="info">
          <Text weight="bold" color="darker800" size="300">
            {i18n.t('trainings.classes.salary_hint_result')}
          </Text>{' '}
          = {i18n.t('trainings.classes.salary_hint_formula')}
        </Callout>
        <Box gap="s8">
          <Text size="300" color="textPrimary" weight="semibold">
            {i18n.t(
              'trainings.trainings_revamp.training_class.class_wizard.basic_information_step.reviewed_subsidized_cost'
            )}
          </Text>
          <Text size="200">{i18n.t('trainings.classes.subsidized_cost_desc')}</Text>
          <NumberInput
            size="md"
            label={i18n.t('trainings.classes.subsidized_cost_desc')}
            hideLabel
            locale={i18n.locale}
            units={currency}
            placeholder="0.00"
            onChange={(value) =>
              onDataChanged({ ...data, subsidizedCost: value !== null ? String(value) : '' })
            }
            value={data.subsidizedCost ? Number(data.subsidizedCost) : null}
            maxDecimals={2}
          />
        </Box>
      </Box>
    </Box>
  )
}
